import regex from './regex';

export default regex;
